import React from "react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../lib/brand";

const Footer = () => {
  return (
    <footer className="bg-[#0e2a1e] text-[#f4f2ea] mt-20">
      <div className="max-w-[1400px] mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src={LOGO_URL} alt="Everyone's Budget" className="w-12 h-12 rounded-full object-cover" />
            <h3 className="font-serif-brand text-2xl font-semibold">Everyone's Budget</h3>
          </div>
          <p className="text-sm text-[#f4f2ea]/70 leading-relaxed max-w-xs">
            Mississauga's budget-friendly stop for apparel, footwear, and home goods. Local pick-up only. All sales final—see policies below.
          </p>
        </div>

        {/* Policies */}
        <div>
          <h4 className="text-[#a4d61e] text-xs font-semibold tracking-[0.15em] uppercase mb-5">
            Policies &amp; Help
          </h4>
          <ul className="space-y-3 text-sm text-[#f4f2ea]/85">
            <li><Link to="/info/sizing" className="hover:text-[#a4d61e] transition-colors">Sizing Guide</Link></li>
            <li><Link to="/info/local-pickup" className="hover:text-[#a4d61e] transition-colors">Pick-Up &amp; Order Policy</Link></li>
            <li><Link to="/info/returns" className="hover:text-[#a4d61e] transition-colors">Return Policy (All Sales Final)</Link></li>
            <li><Link to="/info/faq" className="hover:text-[#a4d61e] transition-colors">FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[#a4d61e] transition-colors">Contact Us</Link></li>
          </ul>
        </div>

        {/* Company */}
        <div>
          <h4 className="text-[#a4d61e] text-xs font-semibold tracking-[0.15em] uppercase mb-5">
            Company
          </h4>
          <ul className="space-y-3 text-sm text-[#f4f2ea]/85">
            <li><Link to="/info/about" className="hover:text-[#a4d61e] transition-colors">About Us</Link></li>
            <li><Link to="/donate" className="hover:text-[#a4d61e] transition-colors">Donate</Link></li>
            <li><Link to="/info/customer-service" className="hover:text-[#a4d61e] transition-colors">Customer Service</Link></li>
            <li><Link to="/info/care" className="hover:text-[#a4d61e] transition-colors">Care Instructions</Link></li>
            <li><Link to="/info/privacy" className="hover:text-[#a4d61e] transition-colors">Privacy Policy</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[#f4f2ea]/10">
        <p className="text-center text-xs text-[#f4f2ea]/60 py-6">
          © 2026 Everyone's Budget. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
